import { render, staticRenderFns } from "./FeaturedItem.vue?vue&type=template&id=20aa79c2&scoped=true&"
import script from "./FeaturedItem.vue?vue&type=script&lang=js&"
export * from "./FeaturedItem.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedItem.vue?vue&type=style&index=0&id=20aa79c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aa79c2",
  null
  
)

export default component.exports